<div style="position: relative;">
    <!-- Use id="ReclaimFormFields" only to get column ReclFrmXml for table [ReclaimForms] with rtn createReclaimXml_developmentHelperRtn() -->
    <div>
        <img [src]="reclFormImg64Seled" alt="Form Image" width="100%" height="100%">
    </div>

    <!-- <optMCScomercial></optMCScomercial> -->
    <div class="form-check-input optMCScomercial">
        <input type="radio" id="optMCScomercial" name="plan" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.plan" value="comercial">
    </div>

    <!-- <optMCSadvantage></optMCSadvantage> -->
    <div class="form-check-input optMCSadvantage">
        <input type="radio" id="optMCSadvantage" name="plan" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.plan" value="advantage">
    </div>

    <!-- <optMCSpending></optMCSpending> -->
    <div class="form-check-input optMCSpending">
        <input type="radio" id="optMCSpending" name="typ" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.typ" value="pending">
    </div>

    <!-- <optMCSadjust></optMCSadjust> -->
    <div class="form-check-input optMCSadjust">
        <input type="radio" id="optMCSadjust" name="typ" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.typ" value="adjust">
    </div>

    <!-- <txtMCSprovNm></txtMCSprovNm> -->
    <div class="txtMCSprovNm">
        <input type="text" id="txtMCSprovNm" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSprovNm" style="width: 275px;">
    </div>

    <!-- <txtMCSprovNPI></txtMCSprovNPI> -->
    <div class="txtMCSprovNPI">
        <input type="text" id="txtMCSprovNPI" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSprovNPI" mask="0000000000" style="width: 95px;">
    </div>

    <!-- <txtMCSprovAddPO1></txtMCSprovAddPO1> -->
    <div class="txtMCSprovAddPO1">
        <input type="text" id="txtMCSprovAddPO1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSprovAddPO1" style="width: 330px;">
    </div>

    <!-- <txtMCSprovAddPO2></txtMCSprovAddPO2> -->
    <div class="txtMCSprovAddPO2">
        <input type="text" id="txtMCSprovAddPO2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSprovAddPO2" style="width: 330px;">
    </div>

    <!-- <txtMCSprovAddPOzip></txtMCSprovAddPOzip> -->
    <div class="txtMCSprovAddPOzip">
        <input type="text" id="txtMCSprovAddPOzip" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSprovAddPOzip" mask="00000-0000" style="width: 100px">
    </div>

    <!-- <txtMCSprovAddTel></txtMCSprovAddTel> -->
    <div class="txtMCSprovAddTel">
        <input type="text" id="txtMCSprovAddTel" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSprovAddTel" mask="(000)000-0000" style="width: 170px">
    </div>

    <!-- <txtMCSprovEmail></txtMCSprovEmail> -->
    <div class="txtMCSprovEmail">
        <input type="text" id="txtMCSprovEmail" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSprovEmail" style="width: 170px">
    </div>

    <!-- 1 -->
    <!-- <txtMCSpatNm1></txtMCSpatNm1> -->
    <div class="txtMCSpatNm1">
        <input type="text" id="txtMCSpatNm1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSpatNm1" style="width: 180px; height: 20px;">
    </div>

    <!-- <txtMCScontrNo1></txtMCScontrNo1> -->
    <div class="txtMCScontrNo1">
        <input type="text" id="txtMCScontrNo1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCScontrNo1" style="width: 120px; height: 20px;">
    </div>

    <!-- <txtMCSfrmDt1></txtMCSfrmDt1> -->
    <div class="txtMCSfrmDt1">
        <input type="text" id="txtMCSfrmDt1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSfrmDt1" style="width: 90px; height: 20px;" class="text-center">
    </div>

    <!-- <txtMCStoDt1></txtMCStoDt1> -->
    <div class="txtMCStoDt1">
        <input type="text" id="txtMCStoDt1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCStoDt1" style="width: 90px; height: 20px;" class="text-center" mask="00/00/00">
    </div>

    <!-- <txtMCScpt1></txtMCScpt1> -->
    <div class="txtMCScpt1">
        <input type="text" id="txtMCScpt1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCScpt1" style="width: 104px; height: 20px;" size="10" maxlength="10">
    </div>

    <!-- <txtMCSbal1></txtMCSbal1> -->
    <div class="txtMCSbal1">
        <input type="text" id="txtMCSbal1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSbal1" style="width: 104px; height: 20px; text-align: right;" maxlength="100"
            class="currcy" mask="separator.2" thousandSeparator=",">
    </div>

    <!-- <txtMCScoment1></txtMCScoment1> -->
    <div class="txtMCScoment1">
        <input type="text" id="txtMCScoment1" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCScoment1" style="width: 312px; height: 20px;" maxlength="100" class="font10">
    </div>

    <!-- 2 -->
    <!-- <txtMCSpatNm2></txtMCSpatNm2> -->
    <div class="txtMCSpatNm2">
        <input type="text" id="txtMCSpatNm2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSpatNm2" style="width: 180px; height: 20px;">
    </div>

    <!-- <txtMCScontrNo2></txtMCScontrNo2> -->
    <div class="txtMCScontrNo2">
        <input type="text" id="txtMCScontrNo2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCScontrNo2" style="width: 120px; height: 20px;">
    </div>

    <!-- <txtMCSfrmDt2></txtMCSfrmDt2> -->
    <div class="txtMCSfrmDt2">
        <input type="text" id="txtMCSfrmDt2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSfrmDt2" style="width: 90px; height: 20px;" class="text-center">
    </div>

    <!-- <txtMCStoDt2></txtMCStoDt2> -->
    <div class="txtMCStoDt2">
        <input type="text" id="txtMCStoDt2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCStoDt2" style="width: 90px; height: 20px;" class="text-center" mask="00/00/00">
    </div>

    <!-- <txtMCScpt2></txtMCScpt2> -->
    <div class="txtMCScpt2">
        <input type="text" id="txtMCScpt2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCScpt2" style="width: 104px; height: 20px;" size="20" maxlength="20">
    </div>

    <!-- <txtMCSbal2></txtMCSbal2> -->
    <div class="txtMCSbal2">
        <input type="text" id="txtMCSbal2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCSbal2" style="width: 104px; height: 20px;" maxlength="200" class="currcy"
            mask="separator.2" thousandSeparator=",">
    </div>

    <!-- <txtMCScoment2></txtMCScoment2> -->
    <div class="txtMCScoment2">
        <input type="text" id="txtMCScoment2" (click)="onClick($event)" (change)="onChange_need2Save()"
            [(ngModel)]="e.txtMCScoment2" style="width: 312px; height: 20px;" maxlength="200" class="font10">
    </div>

    <!-- 3 -->
    <!-- <txtMCSpatNm3></txtMCSpatNm3> -->
    <div class="txtMCSpatNm3">
        <input type="text" id="txtMCSpatNm3" (click)="onClick($event)" (change)="onChange_need3Save()"
            [(ngModel)]="e.txtMCSpatNm3" style="width: 180px; height: 20px;">
    </div>

    <!-- <txtMCScontrNo3></txtMCScontrNo3> -->
    <div class="txtMCScontrNo3">
        <input type="text" id="txtMCScontrNo3" (click)="onClick($event)" (change)="onChange_need3Save()"
            [(ngModel)]="e.txtMCScontrNo3" style="width: 120px; height: 20px;">
    </div>

    <!-- <txtMCSfrmDt3></txtMCSfrmDt3> -->
    <div class="txtMCSfrmDt3">
        <input type="text" id="txtMCSfrmDt3" (click)="onClick($event)" (change)="onChange_need3Save()"
            [(ngModel)]="e.txtMCSfrmDt3" style="width: 90px; height: 20px;" class="text-center">
    </div>

    <!-- <txtMCStoDt3></txtMCStoDt3> -->
    <div class="txtMCStoDt3">
        <input type="text" id="txtMCStoDt3" (click)="onClick($event)" (change)="onChange_need3Save()"
            [(ngModel)]="e.txtMCStoDt3" style="width: 90px; height: 20px;" class="text-center" mask="00/00/00">
    </div>

    <!-- <txtMCScpt3></txtMCScpt3> -->
    <div class="txtMCScpt3">
        <input type="text" id="txtMCScpt3" (click)="onClick($event)" (change)="onChange_need3Save()"
            [(ngModel)]="e.txtMCScpt3" style="width: 104px; height: 20px;" size="30" maxlength="30">
    </div>

    <!-- <txtMCSbal3></txtMCSbal3> -->
    <div class="txtMCSbal3">
        <input type="text" id="txtMCSbal3" (click)="onClick($event)" (change)="onChange_need3Save()"
            [(ngModel)]="e.txtMCSbal3" style="width: 104px; height: 20px;" maxlength="300" class="currcy"
            mask="separator.2" thousandSeparator=",">
    </div>

    <!-- <txtMCScoment3></txtMCScoment3> -->
    <div class="txtMCScoment3">
        <input type="text" id="txtMCScoment3" (click)="onClick($event)" (change)="onChange_need3Save()"
            [(ngModel)]="e.txtMCScoment3" style="width: 312px; height: 20px;" maxlength="300" class="font10">
    </div>

    <!-- 4 -->
    <!-- <txtMCSpatNm4></txtMCSpatNm4> -->
    <div class="txtMCSpatNm4">
        <input type="text" id="txtMCSpatNm4" (click)="onClick($event)" (change)="onChange_need4Save()"
            [(ngModel)]="e.txtMCSpatNm4" style="width: 180px; height: 20px;">
    </div>

    <!-- <txtMCScontrNo4></txtMCScontrNo4> -->
    <div class="txtMCScontrNo4">
        <input type="text" id="txtMCScontrNo4" (click)="onClick($event)" (change)="onChange_need4Save()"
            [(ngModel)]="e.txtMCScontrNo4" style="width: 120px; height: 20px;">
    </div>

    <!-- <txtMCSfrmDt4></txtMCSfrmDt4> -->
    <div class="txtMCSfrmDt4">
        <input type="text" id="txtMCSfrmDt4" (click)="onClick($event)" (change)="onChange_need4Save()"
            [(ngModel)]="e.txtMCSfrmDt4" style="width: 90px; height: 20px;" class="text-center">
    </div>

    <!-- <txtMCStoDt4></txtMCStoDt4> -->
    <div class="txtMCStoDt4">
        <input type="text" id="txtMCStoDt4" (click)="onClick($event)" (change)="onChange_need4Save()"
            [(ngModel)]="e.txtMCStoDt4" style="width: 90px; height: 20px;" class="text-center" mask="00/00/00">
    </div>

    <!-- <txtMCScpt4></txtMCScpt4> -->
    <div class="txtMCScpt4">
        <input type="text" id="txtMCScpt4" (click)="onClick($event)" (change)="onChange_need4Save()"
            [(ngModel)]="e.txtMCScpt4" style="width: 104px; height: 20px;" size="40" maxlength="40">
    </div>

    <!-- <txtMCSbal4></txtMCSbal4> -->
    <div class="txtMCSbal4">
        <input type="text" id="txtMCSbal4" (click)="onClick($event)" (change)="onChange_need4Save()"
            [(ngModel)]="e.txtMCSbal4" style="width: 104px; height: 20px;" maxlength="400" class="currcy"
            mask="separator.2" thousandSeparator=",">
    </div>

    <!-- <txtMCScoment4></txtMCScoment4> -->
    <div class="txtMCScoment4">
        <input type="text" id="txtMCScoment4" (click)="onClick($event)" (change)="onChange_need4Save()"
            [(ngModel)]="e.txtMCScoment4" style="width: 312px; height: 20px;" maxlength="400" class="font10">
    </div>

    <!-- 5 -->
    <!-- <txtMCSpatNm5></txtMCSpatNm5> -->
    <div class="txtMCSpatNm5">
        <input type="text" id="txtMCSpatNm5" (click)="onClick($event)" (change)="onChange_need5Save()"
            [(ngModel)]="e.txtMCSpatNm5" style="width: 180px; height: 20px;">
    </div>

    <!-- <txtMCScontrNo5></txtMCScontrNo5> -->
    <div class="txtMCScontrNo5">
        <input type="text" id="txtMCScontrNo5" (click)="onClick($event)" (change)="onChange_need5Save()"
            [(ngModel)]="e.txtMCScontrNo5" style="width: 120px; height: 20px;">
    </div>

    <!-- <txtMCSfrmDt5></txtMCSfrmDt5> -->
    <div class="txtMCSfrmDt5">
        <input type="text" id="txtMCSfrmDt5" (click)="onClick($event)" (change)="onChange_need5Save()"
            [(ngModel)]="e.txtMCSfrmDt5" style="width: 90px; height: 20px;" class="text-center">
    </div>

    <!-- <txtMCStoDt5></txtMCStoDt5> -->
    <div class="txtMCStoDt5">
        <input type="text" id="txtMCStoDt5" (click)="onClick($event)" (change)="onChange_need5Save()"
            [(ngModel)]="e.txtMCStoDt5" style="width: 90px; height: 20px;" class="text-center" mask="00/00/00">
    </div>

    <!-- <txtMCScpt5></txtMCScpt5> -->
    <div class="txtMCScpt5">
        <input type="text" id="txtMCScpt5" (click)="onClick($event)" (change)="onChange_need5Save()"
            [(ngModel)]="e.txtMCScpt5" style="width: 104px; height: 20px;" size="50" maxlength="50">
    </div>

    <!-- <txtMCSbal5></txtMCSbal5> -->
    <div class="txtMCSbal5">
        <input type="text" id="txtMCSbal5" (click)="onClick($event)" (change)="onChange_need5Save()"
            [(ngModel)]="e.txtMCSbal5" style="width: 104px; height: 20px;" maxlength="500" class="currcy"
            mask="separator.2" thousandSeparator=",">
    </div>

    <!-- <txtMCScoment5></txtMCScoment5> -->
    <div class="txtMCScoment5">
        <input type="text" id="txtMCScoment5" (click)="onClick($event)" (change)="onChange_need5Save()"
            [(ngModel)]="e.txtMCScoment5" style="width: 312px; height: 20px;" maxlength="500" class="font10">
    </div>

    <!-- 6 -->
    <!-- <txtMCSpatNm6></txtMCSpatNm6> -->
    <div class="txtMCSpatNm6">
        <input type="text" id="txtMCSpatNm6" (click)="onClick($event)" (change)="onChange_need6Save()"
            [(ngModel)]="e.txtMCSpatNm6" style="width: 180px; height: 20px;">
    </div>

    <!-- <txtMCScontrNo6></txtMCScontrNo6> -->
    <div class="txtMCScontrNo6">
        <input type="text" id="txtMCScontrNo6" (click)="onClick($event)" (change)="onChange_need6Save()"
            [(ngModel)]="e.txtMCScontrNo6" style="width: 120px; height: 20px;">
    </div>

    <!-- <txtMCSfrmDt6></txtMCSfrmDt6> -->
    <div class="txtMCSfrmDt6">
        <input type="text" id="txtMCSfrmDt6" (click)="onClick($event)" (change)="onChange_need6Save()"
            [(ngModel)]="e.txtMCSfrmDt6" style="width: 90px; height: 20px;" class="text-center">
    </div>

    <!-- <txtMCStoDt6></txtMCStoDt6> -->
    <div class="txtMCStoDt6">
        <input type="text" id="txtMCStoDt6" (click)="onClick($event)" (change)="onChange_need6Save()"
            [(ngModel)]="e.txtMCStoDt6" style="width: 90px; height: 20px;" class="text-center" mask="00/00/00">
    </div>

    <!-- <txtMCScpt6></txtMCScpt6> -->
    <div class="txtMCScpt6">
        <input type="text" id="txtMCScpt6" (click)="onClick($event)" (change)="onChange_need6Save()"
            [(ngModel)]="e.txtMCScpt6" style="width: 104px; height: 20px;" size="60" maxlength="60">
    </div>

    <!-- <txtMCSbal6></txtMCSbal6> -->
    <div class="txtMCSbal6">
        <input type="text" id="txtMCSbal6" (click)="onClick($event)" (change)="onChange_need6Save()"
            [(ngModel)]="e.txtMCSbal6" style="width: 104px; height: 20px;" maxlength="600" class="currcy"
            mask="separator.2" thousandSeparator=",">
    </div>

    <!-- <txtMCScoment6></txtMCScoment6> -->
    <div class="txtMCScoment6">
        <input type="text" id="txtMCScoment6" (click)="onClick($event)" (change)="onChange_need6Save()"
            [(ngModel)]="e.txtMCScoment6" style="width: 312px; height: 20px;" maxlength="600" class="font10">
    </div>

    <!-- 7 -->
    <!-- <txtMCSpatNm7></txtMCSpatNm7> -->
    <div class="txtMCSpatNm7">
        <input type="text" id="txtMCSpatNm7" (click)="onClick($event)" (change)="onChange_need7Save()"
            [(ngModel)]="e.txtMCSpatNm7" style="width: 180px; height: 20px;">
    </div>

    <!-- <txtMCScontrNo7></txtMCScontrNo7> -->
    <div class="txtMCScontrNo7">
        <input type="text" id="txtMCScontrNo7" (click)="onClick($event)" (change)="onChange_need7Save()"
            [(ngModel)]="e.txtMCScontrNo7" style="width: 120px; height: 20px;">
    </div>

    <!-- <txtMCSfrmDt7></txtMCSfrmDt7> -->
    <div class="txtMCSfrmDt7">
        <input type="text" id="txtMCSfrmDt7" (click)="onClick($event)" (change)="onChange_need7Save()"
            [(ngModel)]="e.txtMCSfrmDt7" style="width: 90px; height: 20px;" class="text-center">
    </div>

    <!-- <txtMCStoDt7></txtMCStoDt7> -->
    <div class="txtMCStoDt7">
        <input type="text" id="txtMCStoDt7" (click)="onClick($event)" (change)="onChange_need7Save()"
            [(ngModel)]="e.txtMCStoDt7" style="width: 90px; height: 20px;" class="text-center" mask="00/00/00">
    </div>

    <!-- <txtMCScpt7></txtMCScpt7> -->
    <div class="txtMCScpt7">
        <input type="text" id="txtMCScpt7" (click)="onClick($event)" (change)="onChange_need7Save()"
            [(ngModel)]="e.txtMCScpt7" style="width: 104px; height: 20px;" size="70" maxlength="70">
    </div>

    <!-- <txtMCSbal7></txtMCSbal7> -->
    <div class="txtMCSbal7">
        <input type="text" id="txtMCSbal7" (click)="onClick($event)" (change)="onChange_need7Save()"
            [(ngModel)]="e.txtMCSbal7" style="width: 104px; height: 20px;" maxlength="700" class="currcy"
            mask="separator.2" thousandSeparator=",">
    </div>

    <!-- <txtMCScoment7></txtMCScoment7> -->
    <div class="txtMCScoment7">
        <input type="text" id="txtMCScoment7" (click)="onClick($event)" (change)="onChange_need7Save()"
            [(ngModel)]="e.txtMCScoment7" style="width: 312px; height: 20px;" maxlength="700" class="font10">
    </div>

    <!-- footer -->
    <footer class="footer font10">
        {{engLang ? 'Prepared by:':'Preparado
        por:'}}&nbsp;{{this.userLastNm + ', ' + this.userFirstNm + ' (' + this.userID +
        ')'}}&nbsp;{{e.date}}&nbsp;{{engLang ? 'Claim #:' : 'Caso #:'}}{{e.casNo}}
        &nbsp;&nbsp;&nbsp;MedicalBiller.us&nbsp;medbiler&#64;gmail.com&nbsp;&nbsp;&nbsp;{{sn}}
    </footer>

</div>